/**
 * Copyright (c) 2017-present, Tomaruba, Inc.
 * All rights reserved.
 *
 */
import { ReduceStore } from 'flux/utils'
import AppDispatcher from '../../core/AppDispatcher'
import { CheckInSearchState } from '../state/CheckInSearchState'
import ReservationEvent from '../../event/ReservationEvent'
import CheckInEvent from '../../event/CheckInEvent'

class CheckInSearchStore extends ReduceStore {
  constructor() {
    super(AppDispatcher)
  }

  getInitialState() {
    return new CheckInSearchState()
  }

  reduce(state, action) {
    const payload = action.payload

    switch (action.type) {
      case CheckInEvent.onEditSearchCondition:
        return state.set(payload.name, payload.value)

      case ReservationEvent.fetchRooms:
        const options = payload.rooms.map(room => {
          return { value: room.id, label: room.name }
        })
        return state.merge({
          search_room_options: options,
          loading_room_option: false
        })

      default:
        return state
    }
  }
}

export default new CheckInSearchStore()
